import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import SubHeader from "../ProcessSteps/Parts/SubHeader";
import Header from "../ProcessSteps/Parts/Header";
import {Redirect} from "react-router";

class DidNotSignBy1Ct extends Component {
    constructor(props){
        super(props);

        this.state = {
            redirect_url: null,
        };
    }

    render() {
        if ( this.state.redirect_url !== null && this.state.redirect_url !== undefined) {
            return <Redirect push={true} to={this.state.redirect_url} />
        }

        return (
            <div>
                <Header title={this.props.t('step.error')}/>
                <div className="section window-layout">
                    <div className="container frame">
                        <SubHeader/>

                        <div className="row py-5">

                            <div className="col-12 d-flex justify-content-center text-center mt-4">
                                <p className="heading--2">
                                    <span>Jūsų mokėjimas buvo atšauktas, pasirinkite dokumento pasirašymo būdą iš naujo </span>
                                </p>
                            </div>
                            <div className="col-12 d-flex justify-content-center text-center mt-4">

                                <div className="btn-primary btn"
                                     onClick={() => {this.setState({redirect_url: this.props.url})}
                                     }>
                                    {this.props.t('forms.try_again')}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(DidNotSignBy1Ct);
